import React from "react";
import "./CourseDetails.css";
import { LuClock10 } from "react-icons/lu";
import { format } from "date-fns";
import { Button } from "react-bootstrap";
const badgeColors = {
  Advanced: "rgb(241, 77, 104)",
  Intermediate: "rgb(103, 123, 250)",
  Beginner: "rgb(21, 214, 66)",
};
const CourseDetails = ({ courses }) => {
  const formatDate = (date) => {
    return format(new Date(date), "MMM yyyy");
  };
  return (
    <div className="course-container">
      {courses.map((course, index) => (
        <div>
          <div
            key={index}
            className={`course-card ${index % 2 === 0 ? "left" : "right"}`}
          >
            <div className="course-img-container">
              <a
                href={course.courseLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={course.image}
                  alt={`${course.name} course`}
                  className="course-img"
                />
              </a>
              <div
                className="course-badge"
                style={{ backgroundColor: badgeColors[course.difficulty] }}
              >
                {course.difficulty}
              </div>
              <div className="course-details">
                <p className="course-duration">
                  {<LuClock10 />} {course.duration} Hours
                </p>
                <p className="course-completion-date">
                  Completed: {formatDate(course.completeDate)}
                </p>
              </div>
              <div className="course-progress-container des">
                <p className="course-completion">
                  {course.completionPercentage}% Completed
                </p>
                <div className="course-progress">
                  <span
                    className="progress-bar"
                    style={{ width: `${course.completionPercentage}%` }}
                  ></span>
                </div>
              </div>
            </div>

            <div className="course-info">
              <div className="course-header">
                <h2 className="course-title">{course.name}</h2>
                <p className="course-instructor">{course.instructor}</p>
              </div>
              {course.certificate && (
                <Button
                  href={course.certificate}
                  target="_blank"
                  className="fork-btn-inner"
                >
                  Certificate
                </Button>
              )}
              <p className="course-description">{course.description}</p>

              <div className="course-progress-container mob">
                <p className="course-completion">
                  {course.completionPercentage}% Completed
                </p>
                <div className="course-progress">
                  <span
                    className="progress-bar"
                    style={{ width: `${course.completionPercentage}%` }}
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CourseDetails;
